// File: components/BenefitsServicesDetailsDesktop.client.tsx (CLIENT - animacja 1:1)
"use client";

import * as React from "react";
import Image from "next/image";
import { LazyMotion, domAnimation, m, useScroll, useTransform, type MotionValue } from "framer-motion";
import type { BenefitDetailItem } from "./BenefitsServicesDetails";

type Props = {
    items: BenefitDetailItem[];
    sectionHeading?: string;
    sectionDescription?: string;
};

function DesktopTextItem({
                             item,
                             index,
                             total,
                             scrollYProgress,
                         }: {
    item: BenefitDetailItem;
    index: number;
    total: number;
    scrollYProgress: MotionValue<number>;
}) {
    const start = index / total;
    const end = (index + 1) / total;

    const opacity = useTransform(
        scrollYProgress,
        [Math.max(0, start - 0.07), start, end - 0.07, Math.min(1, end)],
        [0, 1, 1, 0]
    );

    return (
        <m.div style={{ opacity }} className="md:absolute md:flex md:h-screen md:flex-col md:justify-center">
            {/* ZMIANA 1: Zmniejszamy margines prawy na tablecie (md:mr-6), duży wraca na lg (lg:mr-20) */}
            <div className="max-w-md md:ml-[5vw] md:mr-6 lg:mr-20">

                {/* ZMIANA 2: Stopniowanie czcionki.
                    md:text-4xl (tablet - mniejsze, żeby weszło)
                    lg:text-6xl (mały laptop)
                    xl:text-7xl (duży ekran - jak było)
                    Dodano hyphens-auto i break-words dla długich słów.
                */}
                <h3
                    className="font-medium md:mb-6 md:text-4xl lg:text-6xl xl:text-7xl hyphens-auto break-words"
                    lang="pl"
                >
                    {item.heading}
                </h3>

                <p className="md:text-md">{item.description}</p>
                <div className="flex flex-wrap items-center gap-4 md:mt-8" />
            </div>
        </m.div>
    );
}

export default function BenefitsServicesDetailsDesktop({ items, sectionHeading, sectionDescription }: Props) {
    const data = items ?? [];
    const containerRef = React.useRef<HTMLDivElement>(null);

    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start center", "end center"], // 1:1
    });

    return (
        <LazyMotion features={domAnimation} strict>
            <div ref={containerRef} className="grid grid-cols-2">
                {/* LEFT: sticky content jak było */}
                <div>
                    <div className="flex flex-col gap-y-12 md:sticky md:top-0 md:items-end md:gap-y-0">
                        {data.map((item, index) => (
                            <DesktopTextItem
                                key={`${item.heading}-${index}`}
                                item={item}
                                index={index}
                                total={data.length}
                                scrollYProgress={scrollYProgress}
                            />
                        ))}
                    </div>
                </div>

                {/* RIGHT: pełnoekranowe obrazy (jak było) */}
                <div className="hidden md:block">
                    {data.map((item, index) => (
                        <div key={`img-${index}`} className="relative md:h-screen">
                            <Image
                                src={item.imageUrl}
                                alt={item.imageAlt || item.heading}
                                fill
                                className="object-cover"
                                sizes="50vw"
                                priority={index === 0}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </LazyMotion>
    );
}